module.exports = __webpack_public_path__ + "img/1f606.040c6e7.svg";